<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table :data="material" highlight-current-row @current-change="selectCurrentRow" v-loading="listLoading"
      @selection-change="selsChange" style="width: 100%" height="600" :border="true">
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column prop="Name" label="物资名称"></el-table-column>
      <el-table-column prop="Code" label="物资编码"></el-table-column>
      <el-table-column prop="Remark" label="备注" width="300"></el-table-column>
      <el-table-column prop="CreateTime" label="创建时间" :formatter="formatDate" sortable></el-table-column>
      <el-table-column prop="CreateUser" label="创建者"></el-table-column>
      <el-table-column prop="Status" label="状态" width="">
        <template slot-scope="scope">
          <el-tag :type="scope.row.Status == 0 ? 'success' : 'info'" disable-transitions>
            {{ scope.row.Status == 0 ? "正常" : "归档" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-link v-if="canEdit" type="primary" @click="() => {
              currentRow = scope.row;
              handleEdit();
            }
            ">
            编辑
          </el-link>
          <el-link v-if="canDelete" type="danger" @click="() => {
              sels.push(scope.row);
              handleDel();
            }
            ">
            删除
          </el-link>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-size="pageSize" :total="total"
      @current-change="handleCurrentChange" @size-change="handleSizeChange" class="my-pagination"></el-pagination>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="120px" :rules="editFormRules" ref="editForm">
        <el-form-item label="物资名称" prop="Name">
          <el-input v-model="editForm.Name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="物资编码" prop="Code">
          <el-input v-model="editForm.Code" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="物资规格" prop="MatGrade">
          <el-input v-model="editForm.MatGrade" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="折方系数" prop="CubRate">
          <el-input v-model="editForm.CubRate" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="物资类型" prop="MatClassName">
          <el-input v-model="editForm.MatClassName" class="input-select" readonly />
          <el-button type="primary" @click="visibleDialog = true" :loading="editLoading">
            选择
          </el-button>
        </el-form-item>
        <el-form-item label="工控机物资映射" prop="PlcMaterialName">
          <el-input v-model="editForm.PlcMaterialName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="工控机仓库映射" prop="PlcWarehouseName">
          <el-input v-model="editForm.PlcWarehouseName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否原材料" prop="IsYCL">
          <el-select v-model="editForm.IsYCL" placeholder="请选择">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-select v-model="editForm.Status" placeholder="请选择状态">
            <el-option label="正常" :value="0"></el-option>
            <el-option label="归档" :value="-1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input type="textarea" v-model="editForm.Remark" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">
          提交
        </el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
      <el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm">
        <el-form-item label="物资名称" prop="Name">
          <el-input v-model="addForm.Name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="物资编码" prop="Code">
          <el-input v-model="addForm.Code" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="物资规格" prop="MatGrade">
          <el-input v-model="addForm.MatGrade" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="折方系数" prop="CubRate">
          <el-input v-model="addForm.CubRate" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="物资类型" prop="MatClassName">
          <el-input v-model="addForm.MatClassName" class="input-select" readonly />
          <el-button type="primary" @click="visibleDialog = true" :loading="editLoading">
            选择
          </el-button>
        </el-form-item>
        <el-form-item label="工控机物资映射" prop="PlcMaterialName">
          <el-input v-model="addForm.PlcMaterialName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="工控机仓库映射" prop="PlcWarehouseName">
          <el-input v-model="addForm.PlcWarehouseName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否原材料" prop="IsYCL">
          <el-select v-model="addForm.IsYCL" placeholder="请选择">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-select v-model="addForm.Status" placeholder="请选择状态">
            <el-option label="正常" :value="0"></el-option>
            <el-option label="归档" :value="-1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input type="textarea" v-model="addForm.Remark" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">
          提交
        </el-button>
      </div>
    </el-dialog>
    <TableDataDialog title="类型选择" :visibleDialog="visibleDialog" :queryMethod="queryData" :columns="{
      Name: {
        label: '类型名称',
      },
      Remark: {
        label: '备注',
      },
      CreateTime: {
        label: '创建时间',
        filter: (item) => {
          return formatDate(item.CreateTime);
        },
      },
      CreateUser: {
        label: '创建时间',
      },
    }" @getDialogVisible="setVisible" @callback="dialogCallback"></TableDataDialog>
  </section>
</template>

<script>
//引入Material.js的所有export的对象,并起别名为api,通过api.***访问成员
import * as api from "../../api/material";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import { getMaterialClassListPage } from "../../api/materialClass";
import TableDataDialog from "../../components/TableDataDialog";

export default {
  components: { Toolbar, TableDataDialog },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      filters: {
        name: "",
      },
      material: [],
      total: 0,
      page: 1,
      pageSize: 20,
      listLoading: false,
      sels: [], //列表选中列
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        Name: [{ required: true, message: "请输入物资名称", trigger: "blur" }],
      },
      //编辑界面数据
      editForm: {
        Name: "",
        Code: "",
        IsYCL: 0,
        plcMaterialName: "",
        plcWarehouseName: "",
        matClassID: "",
        matClassName: "",
        matClassTypeCode: "",
        Remark: "",
        Status: 0,
      },
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        Name: [{ required: true, message: "请输入物资名称", trigger: "blur" }],
      },
      //新增界面数据
      addForm: {
        Name: "",
        Code: "",
        IsYCL: 0,
        plcMaterialName: "",
        plcWarehouseName: "",
        matClassID: "",
        matClassName: "",
        matClassTypeCode: "",
        Remark: "",
        Status: 0,
      },
      visibleDialog: false,
    };
  },
  computed: {
    //计算属性,判断是否有权编辑
    canEdit() {
      let index = this.buttonList.findIndex((s) => s.name === "编辑");
      return index > -1;
    },
    //计算属性,判断是否有权删除
    canDelete() {
      let index = this.buttonList.findIndex((s) => s.name === "删除");
      return index > -1;
    },
  },
  methods: {
    //单击表格行事件绑定方法
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    //工具条绑定事件方法
    callFunction(item) {
      this.page = 1;
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.page = val;
      this.getMaterial();
    },
    //获取物资
    getMaterial() {
      let para = {
        page: this.page,
        key: this.filters.name,
        intPageSize: this.pageSize,
      };
      this.listLoading = true;
      api.getMaterialListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.material = res.data.response.data;
        this.listLoading = false;

        this.currentRow = null;
        this.sels = [];
      });
    },
    //执行删除
    handleDel() {
      if (!this.sels || this.sels.length <= 0) {
        this.$message({
          message: "请勾选要删除的数据",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除选中的记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;

          let para = this.sels.map((item) => item.Id);

          api.batchDeleteMaterial(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getMaterial();
          });
        })
        .catch(() => { })
        .finally(() => {
          this.listLoading = false;
        });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        CreateUser: "",
      };
    },
    //执行编辑
    editSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;
          let para = Object.assign({}, this.editForm);
          let user = JSON.parse(window.localStorage.user);
          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "用户信息为空，先登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }
          api
            .editMaterial(para)
            .then((res) => {
              if (res && res.data && res.data.success) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getMaterial();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            })
            .finally(() => {
              this.editLoading = false;
            });
        }
      });
    },
    //执行新增
    addSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;
          let para = Object.assign({}, this.addForm);
          let user = JSON.parse(window.localStorage.user);

          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "登录信息已过期,请重新登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }

          api
            .addMaterial(para)
            .then((res) => {
              if (res && res.data && res.data.success) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getMaterial();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            })
            .finally(() => {
              this.addLoading = false;
            });
        }
      });
    },
    //勾选表格数据事件绑定方法
    selsChange(sels) {
      this.sels = sels;
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.page = 1;
      this.pageSize = size;
      this.getMaterial();
    },
    dialogCallback(data) {
      if (data.length > 0) {
        this.addForm.MatClassName = data[0].Name;
        this.addForm.MatClassID = data[0].Id;
        this.addForm.MatClassTypeCode = data[0].TypeCode;

        this.editForm.MatClassName = data[0].Name;
        this.editForm.MatClassID = data[0].Id;
        this.editForm.MatClassTypeCode = data[0].TypeCode;
      }
      this.visibleDialog = false;
    },
    queryData(params) {
      return getMaterialClassListPage(params);
    },
    setVisible(val) {
      this.visibleDialog = val;
    },
  },
  mounted() {
    this.getMaterial();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style lang="less" scoped>
.input-select {
  width: 300px;
}
</style>
